import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import {
  Cancel as NonAcceptanceIcon,
} from '@mui/icons-material';
import { styled } from '@mui/styles';


/*** Using the Material UI Emotion Styling library, declare 'styled' instances for each area/object. 
 *** NOTE: These must be declared outside of the React Functional Component to ensure that the styled 
 *** objects will be properly rendered within the DOM. 
 ***/

// a styled Button
const StyledButton = styled((props: ButtonProps) => (
  <Button
    variant="outlined"
    {...props}
  />
))(({ theme }) => ({
  padding: theme.spacing(1, 2),
  color: theme.dialog.nonAcceptanceButton.color,
  border: theme.dialog.nonAcceptanceButton.border,
  background: theme.dialog.nonAcceptanceButton.background,
  '&:hover': {
    border: theme.dialog.nonAcceptanceButton.hoverBorder,
    background: theme.dialog.nonAcceptanceButton.hoverBackground,
    color: theme.dialog.nonAcceptanceButton.hoverColor,
  },
  '&:disabled': {
    border: theme.dialog.nonAcceptanceButton.disabledBorder,
    background: theme.dialog.nonAcceptanceButton.disabledBackground,
    color: theme.dialog.nonAcceptanceButton.disabledColor,
  },
}));
export interface INonAcceptanceButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onNonAcceptance: () => void;
}

const NonAcceptanceButton: React.FC<INonAcceptanceButtonProps> = (props) => {

  // const { children, onNonAcceptance, ...otherProps } = props;
  const { children, onNonAcceptance } = props;

  return (
    <StyledButton
      startIcon={<NonAcceptanceIcon />}
      // {...otherProps}
      // call the onNonAcceptance() handler
      onClick={() => onNonAcceptance()}
    >
      {/* if there are any children to pass on (ie, children !== undefined), pass them on; otherwise, pass an empty React fragment */}
      <>
        {children && children}
      </>
    </StyledButton>
  );
}

export default NonAcceptanceButton;